import { DownloadType as a, DownloadStatus as n } from "../../constants/download.js";
import { platformSchema as s } from "../../../temp-lib/deserialize/yup/platform.js";
import * as e from "ramda";
import * as t from "yup";
const p = t.object({
  url: t.string().default(""),
  updateTime: t.number().default(0),
  version: t.string().default("0.0.0")
}).when(
  ["$data", "$info"],
  (r, u) => {
    const o = e.propOr({}, r.platform.type, u);
    switch (r.type) {
      case a.Store:
      case a.Mobile: {
        const l = e.propOr("", "url", r);
        return t.object().default({
          url: l,
          updateTime: e.propOr(0, "updated_at", o),
          version: e.propOr("0.0.0", "msg", o)
        });
      }
      case a.Direct:
      default:
        return t.object().default({
          url: e.propOr("", "binary_url", o),
          updateTime: e.propOr(0, "updated_at", o),
          version: e.propOr("0.0.0", "msg", o)
        });
    }
  }
), d = t.mixed().oneOf(Object.values(n)).default(n.Ready), f = t.object({
  build: p,
  imageOnly: t.boolean().default(!1),
  name: t.string().default(""),
  platform: s,
  status: d,
  statusText: t.string().default("")
}).from("image_only", "imageOnly").from("status_text", "statusText").noUnknown(!0);
export {
  f as downloadInfoSchema
};
//# sourceMappingURL=download.js.map
